//---------------------------------------------------------------
//		Vars
//---------------------------------------------------------------
var is_free_cookies = false;
var is_member = $('body').data('customer_active');
var box_limit = 12;
var current_cookies_selected = 0;
var popup_is_open = false;
var subscribed_or_about_to = false;

//---------------------------------------------------------------
//		Functions
//---------------------------------------------------------------

function CookiesInit() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  var first_time_offer = getUrlParameter('first-time-offer');
  if (first_time_offer == 'true') {
    $('body').addClass('first-time-offer');
  }

  if ($('body#choose-for-free').length) {
    is_free_cookies = true;
  }

  if (is_free_cookies) {
    if (!is_member) {
      window.location.href = '/';
    }
  }
  selectOneDozen();
  SetInitialCookieLimit();
  filterCookies($('.filter__by').first(), 'Classic');

  /*-------------------------------------
    Subscription stuff
  --------------------------------------*/

  var subscription_choose = getUrlParameter('subscription');
  if (subscription_choose == 'true') {
    $('body').addClass('subscription_choose');
    $('.floating_cookie_picked .cookies-add-to-cart').html(
      'ADD TO SUBSCRIPTION'
    );
    $('.choose-your-own-quantity-picker-wrapper').hide();
    //Checking items in cart for subscriptions
  }

  var subscription_edit = getUrlParameter('edit');
  if (subscription_edit == 'true') {
    $('.floating_cookie_picked .cookies-add-to-cart').html('SAVE COOKIES');
  }

  var order_id = getUrlParameter('order_id');
  var lineitem_key = getUrlParameter('lineitem_key');
  if (order_id) {
    LoadCookiesFromOrderAndSelect(order_id);
  }
  if (lineitem_key) {
    LoadCookiesFromSubscription();
  }

  //loop through cookies to see which ones are members only
  var subscribed = false;

  if (
    subscription_choose ||
    subscription_edit ||
    $('body').data('subscribed') == true
  ) {
    subscribed_or_about_to = true;
  }

  if ($('body').data('subscribed') == true) {
    subscribed = true;
  }

  $('.choose-your-own-selector .choose-your-own-wrapper .SingleCookie').each(
    function (index, cookie) {
      var can_add_to_cart = true;

      if (!$(cookie).hasClass('can_add_to_cart')) {
        can_add_to_cart = false;
      }

      if (can_add_to_cart) {
        $(cookie).find('.join-cookie-club-product-link').hide();
        $(cookie).find('.choose-your-own-qty-container').show();
        if ($(cookie).hasClass('MembersOnly')) {
          if (!subscribed_or_about_to) {
            $(cookie).find('.join-cookie-club-product-link').show();
            $(cookie).find('.choose-your-own-qty-container').hide();
          }
        }
      } else {
        $(cookie).find('.join-cookie-club-product-link').hide();
        $(cookie).find('.choose-your-own-qty-container').hide();
        $(cookie).find('.single-cookies-sold-out').show();
      }
    }
  );

  if (subscribed_or_about_to) {
    $('.choose-your-own-selector .choose-your-own-wrapper .SingleCookie').each(
      function (index, cookie) {
        $(cookie).data('extra-dollar', '0');
      }
    );
  }

  //affiliates stuff
  var affiliates_offer = getUrlParameter('aff');
  if (affiliates_offer == '1') {
    $('.size-dozen-button-scroll').trigger('click');
  }
  if (affiliates_offer == '2') {
    $('.size-two-button-scroll').trigger('click');
  }
}

//functions for adding cookies to box
function LoadCookiesFromSubscription() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  var params = {
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    beforeSend: function () {},

    success: function (data) {
      //Looping through items

      $.each(data.items, function (o, item) {
        debug.log('AJAX : Get Cart Info');
        debug.log(item);
        var item_key = item.key;
        var subscription_key = getUrlParameter('lineitem_key');
        debug.log(item_key);
        debug.log(subscription_key);
        if (item_key == subscription_key) {
          var picked_cookies = item.properties['Picked Cookies'];
          debug.log(picked_cookies);
          if (picked_cookies) PickCookiesFromCommaString(picked_cookies);
          return false;
        }
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest.responseJSON.description);
    },
  };
  jQuery.ajax(params);
}

function PickCookiesFromCommaString(picked_cookies) {
  debug.func(console_pre + arguments.callee.name, console_colors);
  var picked_cookies_array = picked_cookies.split(', ');
  $.each(picked_cookies_array, function (i, cookies) {
    var cookies_amount = parseInt(/\(([^)]*)\)/.exec(cookies)[1]);
    var cookies_name = cookies.split(' (')[0];
    var cookies_name_save = cookies_name.replace(
      /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
      '\\$1'
    );
    var cookies_selector =
      ".choose-your-own-selector .SingleCookie .data_wrapper .cookie-data[data-title='" +
      cookies_name +
      "']";

    debug.log(cookies_selector);
    $(cookies_selector)
      .closest('.SingleCookie')
      .find('.custom__quantity__input')
      .attr('value', cookies_amount);
    $(cookies_selector).closest('.SingleCookie').addClass('active_cookie');
  });
  UpdateCookiesSelectedAmount();
}

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

function LoadCookiesFromOrderAndSelect(order_name) {
  debug.func(console_pre + arguments.callee.name, console_colors);
  //var v = randomNumber(100, 99999999999);
  var params = {
    type: 'POST',
    url: lifted_app_host,
    data: {
      func: 'GetOrderMetafield',
      order_name: order_name,
      metafield_key: 'subscriptions',
      metafield_namespace: 'tchip',
      customer_id: customer_id,
    },
    dataType: 'json',
    beforeSend: function () {},
    success: function (data) {
      debug.log('Ajax: GetOrderMetafield : Reponse ------------------------');

      var line_item_id = getUrlParameter('line_item_id');
      //console.log(line_item_id);

      //Populating subscription selected cookies
      var picked_cookies = '';

      var data_json = data;

      if (IsJsonString(data)) {
        data_json = JSON.parse(data);
      } else {
        data_json = data;
      }

      debug.log(data);

      if (data_json['value']) {
        $.each(JSON.parse(data_json['value']), function (key, line_item) {
          if (line_item_id == line_item['id']) {
            $.each(
              line_item['item_properties'],
              function (key, line_item_prop) {
                if (line_item_prop['name'] == 'Picked Cookies') {
                  picked_cookies = line_item_prop['value'];
                  console.log(picked_cookies);
                  if (picked_cookies) {
                    PickCookiesFromCommaString(picked_cookies);
                  }
                  return false;
                }
              }
            );
          }
        });
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest.responseJSON);
    },
  };
  jQuery.ajax(params);
}

function SetInitialCookieLimit() {
  var limit;
  if (is_free_cookies) {
    limit = 12;
  } else {
    var check_box_limit = $('input[name=Size]:checked').val();
    if (check_box_limit == '2 Dozen') {
      limit = 24;
    }
    if (check_box_limit == 'One Dozen') {
      limit = 12;
    }
    if (check_box_limit == 'Half Dozen') {
      limit = 6;
    }
    if (check_box_limit == 'Half Dozen + 1 Candle') {
      limit = 6;
    }
  }

  $('.total_of_cookies_limit').html(limit);
  box_limit = limit;
}

function SetCookieLimit(limit) {
  $('.total_of_cookies_limit').html(limit);
  box_limit = limit;
}

function clickOneDozen(function_this) {
  let scrollable = $(function_this).data('scroll');
  selectOneDozen();
  if (scrollable) {
    scrollToCookieSelection();
  }
}

function clickHalfDozen(function_this) {
  let scrollable = $(function_this).data('scroll');
  selectHalfDozen();
  if (scrollable) {
    scrollToCookieSelection();
  }
}

function clickTwoDozen(function_this) {
  let scrollable = $(function_this).data('scroll');
  selectTwoDozen();
  if (scrollable) {
    scrollToCookieSelection();
  }
}

function clickHalfDozen2Candles(function_this) {
  let scrollable = $(function_this).data('scroll');
  selectHalfDozen2Candles();
  if (scrollable) {
    scrollToCookieSelection();
  }
}
function clickHalfDozen1Candle(function_this) {
  let scrollable = $(function_this).data('scroll');
  selectHalfDozen1Candle();
  if (scrollable) {
    scrollToCookieSelection();
  }
}

function selectOneDozen() {
  $('.cookies-picked-sizes button').removeClass('button-size-picker-active');
  $('.size-dozen-button').addClass('button-size-picker-active');
  $("input[value='One Dozen']").click();
  UpdateCookiesSelectedAmount();
}

function selectHalfDozen() {
  $('.cookies-picked-sizes button').removeClass('button-size-picker-active');
  $('.size-half-button').addClass('button-size-picker-active');
  $("input[value='Half Dozen']").click();
  UpdateCookiesSelectedAmount();
}

function selectTwoDozen() {
  $('.cookies-picked-sizes button').removeClass('button-size-picker-active');
  $('.size-half-button').addClass('button-size-picker-active');
  $("input[value='2 Dozen']").click();
  UpdateCookiesSelectedAmount();
}

function selectHalfDozen2Candles() {
  $('.cookies-picked-sizes button').removeClass('button-size-picker-active');
  $('.size-half-button').addClass('button-size-picker-active');
  $("input[value='Half Dozen + 2 Candles']").click();
  UpdateCookiesSelectedAmount();
}

function selectHalfDozen1Candle() {
  $('.cookies-picked-sizes button').removeClass('button-size-picker-active');
  $('.size-half-button').addClass('button-size-picker-active');
  $("input[value='Half Dozen + 1 Candle']").click();
  UpdateCookiesSelectedAmount();
}

function GetTotalAmountOfCookiesInBox() {
  var amount = $('.cookies-picked-container .current_amount_of_cookies').text();
  return parseInt(amount);
}

function GetCookiesSelectedAmount() {
  var cookies_selected = 0;
  $(
    '.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper.active_cookie'
  ).each(function (index) {
    var cookie_amount = parseInt($(this).find('.quantity__input').val());
    cookies_selected += cookie_amount;
  });
  return cookies_selected;
}

function UpdateCookiesSelectedAmount() {
  //console.log("UpdateCookiesSelectedAmount");
  current_cookies_selected = GetCookiesSelectedAmount();
  $('.current_amount_of_cookies').text(current_cookies_selected);
  CheckCanAddToCart();
}

function CheckCanAddToCart() {
  //console.log("checing extras");
  let extra_dollar_cookie_amount = 0;
  $(
    '.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper.active_cookie.Extra'
  ).each(function (index) {
    var cookie_amount = $(this).find('.custom__quantity__input').val();
    // console.log("found extra");
    if (cookie_amount != 0) {
      if (subscribed_or_about_to) {
      } else {
        extra_dollar_cookie_amount += parseInt(cookie_amount);
      }
    }
  });

  $(
    '.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper.active_cookie.Extra2'
  ).each(function (index) {
    var cookie_amount = $(this).find('.custom__quantity__input').val();
    // console.log("found extra");
    if (cookie_amount != 0) {
      if (subscribed_or_about_to) {
        extra_dollar_cookie_amount += parseInt(cookie_amount) * 1;
      } else {
        extra_dollar_cookie_amount += parseInt(cookie_amount) * 2;
      }
    }
  });

  //console.log(extra_dollar_cookie_amount);
  $('input[value="+' + extra_dollar_cookie_amount + '"]').click();

  if (current_cookies_selected == box_limit) {
    $('.cookies-add-to-cart').removeClass('disabled');
  } else {
    $('.cookies-add-to-cart').addClass('disabled');
  }

  //check for popups
  if (current_cookies_selected == box_limit && box_limit == 6) {
    if (
      $('body').attr('rel') ==
      'baked-goods-bundle-by-fontana-candle-company-x-taylor-chip-cookies'
    ) {
      return;
    }
    OpenUpsalePopup();
  }
}

function ResetSelectedCookies() {
  $('.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper').each(
    function (index) {
      $(this).removeClass('active_cookie');
      $(this).find('.quantity__input').attr('value', 0);
    }
  );
  UpdateCookiesSelectedAmount();
  CheckCanAddToCart();
}

function AddCookiesToSubscription() {
  //update properties
  var formated_cookies = [];
  $(
    '.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper.active_cookie'
  ).each(function (index) {
    var cookie_name = $(this).find('.cookie-data').data('title');
    var cookie_amount = $(this).find('.custom__quantity__input').val();
    formated_cookies.push(cookie_name + ' (' + cookie_amount + ')');
  });

  formated_cookies = ConvertListToCommaSeperated(formated_cookies);
  $('.hidden_picked_cookies').attr('value', formated_cookies);

  //hide select cookies
  $('.subscription_choose .choose-your-own-selector').hide();
  $('.make-your-own-thankyou-subscription').show();

  var order_id = getUrlParameter('order_id');
  var lineitem_key = getUrlParameter('lineitem_key');
  var line_item_id = getUrlParameter('line_item_id');

  if (order_id) {
    //we're updating a subscription order's metafields
    debug.log('UPDATING METAFIELDS');
    var params = {
      type: 'POST',
      url: lifted_app_host,
      data: {
        func: 'UpdateOrderMetafield',
        order_name: order_id,
        metafield_key: 'subscriptions',
        metafield_namespace: 'tchip',
        metafield_value: formated_cookies,
        line_item_id: line_item_id,
        customer_id: customer_id,
      },
      dataType: 'json',
      beforeSend: function () {},
      success: function (data) {
        debug.log(
          'Ajax: UpdateOrderMetafield : Reponse ------------------------'
        );
        console.log(data);
        //var json_data = JSON.parse(data);
        //console.log(json_data);
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest);
      },
    };
    jQuery.ajax(params);
  }
  if (lineitem_key) {
    //we're updating a subscription in the cart
    //Checking items in cart for subscriptions
    var params = {
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      beforeSend: function () {},

      success: function (data) {
        //Looping through items
        $.each(data.items, function (o, item) {
          debug.log(item);
          var item_key = item.key;
          var subscription_key = getUrlParameter('lineitem_key');
          if (item_key == subscription_key) {
            var new_item_properties = {
              'Selected Subscription': item.properties['Selected Subscription'],
              'Picked Cookies': formated_cookies,
              'Preferred Delivery Date':
                item.properties['Preferred Delivery Date'],
              'Bake Date': item.properties['Bake Date'],
            };
            //new_item_properties.push(selected_cookies);
            //console.log(new_item_properties);
            //console.log(item.properties['Selected Subscription']);
            //Found matching subscriptions to URL parameter
            //Updating subscription properties
            var prod_data = {
              id: subscription_key,
              properties: new_item_properties,
            };

            var params = {
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: prod_data,
              beforeSend: function () {},

              success: function (data) {
                //subscription properties updated, open cart
                const cartNotification =
                  document.querySelector('cart-notification');
                cartNotification.renderContents(true);
              },
              error: function (XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest.responseJSON.description);
              },
            };
            jQuery.ajax(params);
            return false;
          }
        });
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest.responseJSON.description);
      },
    };
    jQuery.ajax(params);
  }
}

function AddCookiesToCart() {
  //console.log("adding cookies");
  /*
  $('.product-form__submit').removeClass("disabled");
  $(".cookies-add-to-cart").removeClass("disabled").removeAttr("disabled");
  $('.product-form__submit').removeClass("add_to_cart_after_variant_load");
  */
  //select extra price variants

  //update properties
  var formated_cookies = [];
  $(
    '.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper.active_cookie'
  ).each(function (index) {
    var cookie_name = $(this).find('.cookie-data').data('title');
    var cookie_amount = $(this).find('.custom__quantity__input').val();
    formated_cookies.push(cookie_name + ' (' + cookie_amount + ')');
  });

  formated_cookies = ConvertListToCommaSeperated(formated_cookies);
  $('.hidden_picked_cookies').attr('value', formated_cookies);

  //submit
  if (!popup_is_open) {
    /*
    $('.product-form__submit').addClass("add_to_cart_after_variant_load"); 
    $('.product-form__submit').addClass("disabled");
    */
    $('.product-form__submit').click();
  }
}

//functions for page rendering
function filterCookies(selector, selected_filter) {
  $('.choose__your__own__single__cookie_wrapper').hide();
  $('.' + selected_filter).show();
  $('.filter__by').removeClass('cookie_filter_active');
  $(selector).addClass('cookie_filter_active');
}

function scrollToCookieSelection() {
  var header_height = $('#shopify-section-header').height();
  $('html, body').animate(
    {
      scrollTop:
        $('.choose_your_own_cookies_filter').offset().top - header_height,
    },
    600
  );
}

function showOverlay() {
  $('.pink-overlaybg').show();
}

function hideOverlay() {
  $('.pink-overlaybg').hide();
}

function CloseUpsalePopup(thepopup) {
  $('.floating_cookie_picked').show();
  hideOverlay();
  $(thepopup).closest('.popup').hide();
  popup_is_open = false;
}

function OpenUpsalePopup() {
  $('.floating_cookie_picked').hide();
  showOverlay();
  $('.upsale__cokies__popup').show();
  popup_is_open = true;
}

function updateCookieAmount() {}

//---------------------------------------------------------------
//		jQuery Events
//---------------------------------------------------------------
$(document).ready(function () {
  CookiesInit();
});

$('.size-dozen-button-scroll').on('click', function (event) {
  event.preventDefault();
  clickOneDozen(this);
});

$('.size-half-button-scroll').on('click', function (event) {
  event.preventDefault();
  clickHalfDozen(this);
});

$('.size-two-button-scroll').on('click', function (event) {
  event.preventDefault();
  clickTwoDozen(this);
});

$('.size-half-1-candle-button-scroll').on('click', function (event) {
  event.preventDefault();
  clickHalfDozen1Candle(this);
});
$('.size-half-2-candles-button-scroll').on('click', function (event) {
  event.preventDefault();
  clickHalfDozen2Candles(this);
});

$('.qty_changer_cookie_choose__your__own').on('click', function (evt) {
  evt.preventDefault();
  let members_only = $(this)
    .closest('.choose__your__own__single__cookie_wrapper')
    .hasClass('MembersOnly');
  let button_action = $(this).data('qty_action');
  let id = $(this)
    .closest('.choose__your__own__single__cookie_wrapper')
    .children('p')
    .attr('id');
  let name = $(this)
    .closest('.choose__your__own__single__cookie_wrapper')
    .children('p')
    .text();
  let extra_dollar = $(this)
    .closest('.choose__your__own__single__cookie_wrapper')
    .data('extra-dollar');
  let current_value = parseInt(
    $(this).siblings('.custom__quantity__input').val()
  );

  if (button_action == 'increase') {
    if (current_cookies_selected >= box_limit) {
      current_value = current_value;
    } else {
      current_value++;
    }
  }
  if (button_action == 'decrease') {
    current_value--;
    if (current_value <= 0) {
      current_value = 0;
    }
  }

  if (current_value >= 1) {
    $(this).parent().parent().addClass('active_cookie');
  } else {
    $(this).parent().parent().removeClass('active_cookie');
  }
  $(this).siblings('.custom__quantity__input').attr('value', current_value);
  UpdateCookiesSelectedAmount();
});

$('variant-radios input[name=Size]').on('click', function (evt) {
  var value_selected = $('input[name=Size]:checked').val();
  if (value_selected == 'Half Dozen') {
    SetCookieLimit(6);
  }
  if (value_selected == 'One Dozen') {
    SetCookieLimit(12);
  }
  if (value_selected == '2 Dozen') {
    SetCookieLimit(24);
  }

  if (box_limit == 6 && GetTotalAmountOfCookiesInBox() > 6) {
    if (
      confirm(
        'This will remove all cookies from box and you will have to start over. Are you sure?'
      )
    ) {
      ResetSelectedCookies();
    }
  }
});

$('.cookies-add-to-cart').on('click', function (evt) {
  if (!$(this).hasClass('disabled')) {
    var subscription_choose = getUrlParameter('subscription');
    if (subscription_choose == 'true') {
      AddCookiesToSubscription();
    } else {
      AddCookiesToCart();
    }
  }
});

//> clear cookies
$('.cookies-clear').on('click', function (evt) {
  $('.choose-your-own-wrapper .choose__your__own__single__cookie_wrapper').each(
    function (index) {
      $(this).find('.custom__quantity__input').attr('value', 0);
      $(this).removeClass('active_cookie');
      UpdateCookiesSelectedAmount();
    }
  );
});

$('.close_upsale').on('click', function (evt) {
  CloseUpsalePopup(this);
});

$('.add_more__cookies__btn_yes').on('click', function (evt) {
  evt.stopPropagation();
  evt.preventDefault();
  selectOneDozen();
  CloseUpsalePopup($('.upsale__cokies__popup'));
});

$('.filter__by').on('click', function (event) {
  let selected_filter = $(this).data('filter_flavor');
  filterCookies(this, selected_filter);
});

//cookie descriptions

/*
$('.pop_up_description').on('click ' ,function(evt){
  let cookie_title =  $(this).closest(".choose__your__own__single__cookie_wrapper").find('.cookie-data').data('title');
  let cookie_description = $(this).closest(".choose__your__own__single__cookie_wrapper").find('.data-description').html();
  let cookie_images = $(this).closest(".choose__your__own__single__cookie_wrapper").find('.cookie-data').find('.cookie-images-ul li');
  $('.thumbnail-images-container').empty();
  $('.cookie-detail-main-image-container').empty();

  $(cookie_images).each(function(i, li) {
    var image = $(li);  
    image =  image.data('image-url');
    $('.thumbnail-images-container').append('<img class="thumb-cookie" src="'+image+'"/>');  
  });

  let main_image = $(cookie_images[0]);
  $('.cookie-detail-main-image-container').append('<img src="'+main_image.data('image-url')+'"/>')  
  $('.cookie-details-text-content .h3').html(cookie_title);
  $('.cookie-details-text-content .p').html(cookie_description);

  $('.cookie__description').show();
  $('.pink-overlaybg').show();
  evt.preventDefault();
});
*/

$('.close__cookie__description').on('click', function (event) {
  event.preventDefault();
  $('.cookie__description').hide();
  $('.pink-overlaybg').hide();
});

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
